import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { ConfirmHost } from '@/ui/ConfirmHost'
import LoginPage from '@/features/auth/pages/LoginPage'
import AgreeTermsPage from '@/features/auth/pages/AgreeTermsPage'
import RegisterPage from '@/features/auth/pages/RegisterPage'
import FindAccountPage from '@/features/auth/pages/FindAccountPage'
import ResetPasswordPage from '@/features/auth/pages/ResetPasswordPage'
import StatisticsPage from '@/features/auth/pages/StatisticsPage'

export default function App() {
  return (
    <>
      <ConfirmHost />
      <Routes>
        <Route path="/" element={<Navigate to="/auth/login" replace />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/agree" element={<AgreeTermsPage />} />
        <Route path="/auth/register" element={<RegisterPage />} />
        <Route path="/auth/find-account" element={<FindAccountPage />} />
        <Route path="/auth/password-reset" element={<ResetPasswordPage />} />
        {/* Embedded by the BookTox admin panel; the page itself requires a
            token handed over by the embedder (see StatisticsPage). */}
        <Route path="/stats" element={<StatisticsPage />} />
        {/* fallback */}
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    </>
  )
}
